import { render, staticRenderFns } from "./BusinessLetter.vue?vue&type=template&id=0556ead6&"
import script from "./BusinessLetter.vue?vue&type=script&lang=js&"
export * from "./BusinessLetter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports